import type { McpServerType, McpConnectionProperties } from '@server/mcp';
import { useSweepApi } from '../sweep/useSweepApi';
import { useCallback } from 'react';

export const useMcpConnectionsApiFacade = () => {
  const sweepApi = useSweepApi();

  return {
    getConnections: useCallback(async (): Promise<McpConnectionProperties[]> => {
      const response = await sweepApi.get('/mcp-connections');
      return response.data;
    }, [sweepApi]),

    registerServer: useCallback(
      async (serverType: McpServerType, serverUrl?: string): Promise<void> => {
        await sweepApi.post(`/mcp-connections/${serverType}/register`, {
          ...(serverUrl && { serverUrl }),
        });
      },
      [sweepApi],
    ),

    getOAuthUrl: useCallback(
      async (serverType: McpServerType): Promise<{ url: string }> => {
        const response = await sweepApi.get(`/mcp-connections/${serverType}/oauth/url`);
        return response.data;
      },
      [sweepApi],
    ),

    handleOAuthCallback: useCallback(
      async (serverType: McpServerType, code: string): Promise<McpConnectionProperties> => {
        const response = await sweepApi.post(`/mcp-connections/${serverType}/oauth/callback`, {
          code,
        });
        return response.data;
      },
      [sweepApi],
    ),

    deleteConnection: useCallback(
      async (connectionId: string): Promise<void> => {
        await sweepApi.delete(`/mcp-connections/${connectionId}`);
      },
      [sweepApi],
    ),
  };
};
